export default __webpack_public_path__ + "static/media/down-black.c65c11f2.svg";